import { DOCUMENT } from '@angular/common';
import { Component, Output, EventEmitter, Input, Inject } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { ILandingPage } from 'src/app/model/http/landing.model';
import { DataService } from 'src/app/services/data.service';
import { KeycloakCustomService } from 'src/app/services/keycloak-custom.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidenav-list',
  templateUrl: `./sidenav-list.component${environment.templateSuffix}.html`,
  styleUrls: ['./sidenav-list.component.scss'],
})
export class SidenavListComponent {

  @Output() sidenavClose = new EventEmitter()
  dataLandingPage: ILandingPage[] = [];
  @Input() userObject!: any;
  @Input() isLoged!: any;
  @Input() processActive!: any;
  urlLocation!: boolean;

  constructor(
    public keycloackService: KeycloakService,
    private dataService: DataService,
    public router: Router,
    @Inject(DOCUMENT) private document: any,
    private keycloakCustomService: KeycloakCustomService
  ) {
    this.dataService.getSideLandingMenu().subscribe((menu) => {
      this.dataLandingPage = menu;
    });
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.urlLocation = event.url.includes('genera-oportunidad');
      }
    });
  }

  getClassCSS(): any {
    return (this.processActive ? 'active' : 'inactive')
  }

  public logout() {
    this.clearSessionData();
    const redirectUri = environment.keycloak.redirectUri;
    const isSalesforceLoggin = this.keycloakCustomService.isLoggin();
    if (isSalesforceLoggin) {
      this.keycloakCustomService.logout(redirectUri);
    } else {
      this.keycloackService.logout(redirectUri);
    }
  }


  private clearSessionData() {
    sessionStorage.removeItem('aceptProcess');
    this.dataService.setIdKeycloak('');
    localStorage.removeItem('dataQuote');
  }

  public onSidenavClose = () => {
    this.sidenavClose.emit();
  };

  /**
   * Scroll to the selected section
   * @param {string} path
   * @memberof SidenavListComponent
   * @author victor.mendez
   */
  clickScroll(path: string) {
    if (this.router.url.includes('home')) {
      this.document.getElementById(path)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      this.router.navigate(['/home'], { fragment: path });
    }
  }

  login() {
    localStorage.setItem('flowType', environment.templateSuffix === '' ? 'A' : 'B');
    this.keycloackService.login();
    this.onSidenavClose();
  }


}